import React from "react";
import PropTypes from "prop-types";
import { Form } from "antd";

import HMGSelect from "./HMGSelect";
import { formItemLayout } from "../../../utils/UI";

const HmgDropdown = (props) => {
  const { value, onChange } = props;

  return (
    <Form.Item label="Hotel Management Group" {...formItemLayout}>
      <HMGSelect value={value} onChange={onChange} />
    </Form.Item>
  );
};

HmgDropdown.defaultProps = {
  value: undefined,
};

HmgDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default HmgDropdown;
